$(document).ready(function () {
  //- Inline  Gallery
  $('.media-carousel-inline .slides').slick({
    speed: 300,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 10,
    centerMode: true,
    adaptiveHeight: true,
  });

  //- Newsletter promo
  $('.newsletter_wrapper .slides').slick({
    speed: 300,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 10,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 820,
        settings: {
          arrows: false,
        },
      },
    ],
  });
  /* ************************************************************* */
  $('.testimonials-carousel__images-wrap').slick({
    asNavFor: '.testimonials-carousel__testimonial',
    arrows: true,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    dots: true,
    dotsClass: 'slider-dots',

    //common options
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    infinite: true,
    draggable: true,
    swipe: true,
    touchMove: true,
    adaptiveHeight: true,
  });
  $('.testimonials-carousel__testimonial').slick({
    asNavFor: '.testimonials-carousel__images-wrap',
    arrows: false,

    //common options
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    infinite: true,
    draggable: true,
    swipe: true,
    touchMove: true,
    adaptiveHeight: true,
  });
});

/* GALLERY */
/* DEPRICATE  */
$('.gallery-slider').slick({
  arrows: true,
  dots: false,
  //common options
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  infinite: true,
  draggable: true,
  swipe: true,
  touchMove: true,
  adaptiveHeight: true,
});
/* ^^^DEPRICATE^^^^  */

/* **** MDL FULL SIZE SLIDER   ***** */
$(document).ready(function(){
  var $status = $(".mdl__slider-dots");
  var $slickElement = $(".mdl-slider");

    $slickElement.on("init reInit afterChange", function (
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.html(
        `<li class="mdl__slider-dot">` +
        i +
        `</li><li class="mdl__slider-dot">/</li>` +
        `<li class="mdl__slider-dot">` +
        slick.slideCount +
        `</li>`
      );
    });

  var mdlOptions = {
    arrows: true,
    dots: false,
    //common options
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: true,
    draggable: true,
    swipe: true,
    touchMove: true,
    adaptiveHeight: true,
  }
  $('.mdl-slider').slick(mdlOptions);

});
$(document).on('click', '.img-group--pointer', function (){
  $('.mdl-slider').slick('refresh');
})





 

/* LOCATION */

/* $('.h-slide__items-wrap').slick({
  slidesToShow: 2,
  variableWidth: true,
  swipeToSlide: true,
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  adaptiveHeight: true,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        variableWidth: false
      }
    },
    {
      breakpoint: 1199,
      settings: "unslick"
    },
  ]
});
$(window).on('resize orientationchange', function () {
  if ($('.h-slide__items-wrap').length) {
    var i = resolutionCheck();
    if (i < 120 && !$('h-slide__items-wrap').hasClass('slick-initialized')) {
      $('.h-slide__items-wrap').slick('refresh');
    }
  }
}); */

/* $(".video_wrapper").each(function () {
  var slidez = $(this).find(".slides");
  slidez.slick({
    nextArrow: slidez.parent().find(".slick-next"),
    prevArrow: slidez.parent().find(".slick-prev"),
    speed: 400,
    slidesToShow: 4,
    touchThreshold: 10,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 3,
          variableWidth: true,
          swipeToSlide: true
        }
      }
    ]
  });
}); */
